export default "__VITE_ASSET__BgjdPGfT__"